<script>
import {status, service, serviceColors, statusColors } from "../../../config/deposit-request"

const cards = [
  {
    title: 'Records',
    icon: 'bars',
    color: null,
    statistic: 'total_records'
  }, {
    title: 'Deposit',
    icon: 'rise',
    color: serviceColors()[service.DEPOSIT_SERVICE_DEPOSIT],
    statistic: 'total_deposit'
  },
  // {
  //   title: 'Loan',
  //   icon: 'stock',
  //   color: serviceColors()[service.DEPOSIT_SERVICE_LOAN],
  //   statistic: 'total_loan'
  // },
  {
    title: 'Withdrawal',
    icon: 'fall',
    color: serviceColors()[service.DEPOSIT_SERVICE_WITHDRAWAL],
    statistic: 'total_withdraw'
  }, {
    title: 'Amount',
    icon: 'dollar',
    color: serviceColors()[service.DEPOSIT_SERVICE_DEPOSIT],
    statistic: 'total_amount',
    suffix: 'IDR'
  },
  // {
  //   title: 'Loan Amount',
  //   icon: 'dollar',
  //   statistic: 'total_loan_amount',
  //   color: serviceColors()[service.DEPOSIT_SERVICE_LOAN],
  //   suffix: 'IDR'
  // }
]

export default {
  computed: {
    statusColors,
    serviceColors,
    statusMap() {
      return Object.fromEntries(new Map(Object.values(status).map((v) => [ v, 'total_' + v])))
    }
  },
  data: () => ({
    cards,
    statistic: null,
    creating: false
  }),
  methods: {
    sync(filters) {
      this.$http.get(this.routeUri('hyperion.finances.deposit.statistic'), { params: filters })
        .then((r) => this.statistic = r.data)
        .catch((e) => this.handleXhrError(e))
    },
    ticked() {
      this.sync(this.$refs.depositList.$props.filters)
      this.$refs.depositList.getItems()
    }
  }
}
</script>
<template>
  <div>
    <a-page-header :ghost="false">
      <template #extra>
        <a-space size="large">
          <h-interval-button @clocked="ticked" />
          <a-button type="primary" icon="plus" @click="() => creating = true">New Deposit</a-button>
        </a-space>
      </template>
      <template #tags>
        <a-tag v-for="(map, status) in statusMap" :key="`tag-${status}`" :color="statusColors[status]" :title="status.toUpperCase()">
          {{ status.charAt(0).toUpperCase() }}: {{ isEmpty(statistic) ? 0 : statistic[map] }}
        </a-tag>
      </template>
      <a-row type="flex" justify="space-between">
        <a-statistic v-for="(item,i) in cards" :key="`card-${i}`"  :title="item.title" :value="isEmpty(statistic) ? 0 : statistic[item.statistic]" :value-style="item.color !== null ? { color: item.color } : {}">
          <template #prefix><a-icon :type="item.icon" /></template>
          <template #suffix v-if="item.hasOwnProperty('suffix')">{{ item.suffix }}</template>
        </a-statistic>
      </a-row>
    </a-page-header>

    <h-deposit-request-list @filtered="sync" ref="depositList" />

    <a-drawer :width="720" placement="right" :closable="true" :visible="creating" @close="() => creating = false">
      <h-deposit-request-form />
    </a-drawer>
  </div>
</template>
